import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { LoginComponent } from './components/login/login.component';
import { OtpComponent } from './components/otp/otp.component';
import { ConsentComponent } from './components/consent/consent.component';
import { ConsentWithoutRadioComponent } from './components/consent-withoutradio/consent-withoutradio.component';
import { DialogModalComponent } from './components/dialog-modal/dialog-modal.component';
import { DialogConsentComponent } from './components/dialog-consent/dialog-consent.component';
import { DialogTncComponent } from './components/dialog-tnc/dialog-tnc.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { DialogConfirmationComponent } from './components/dialog-confirmation/dialog-confirmation.component';
import { DialogConfirmationConsentComponent } from './components/dialog-confirmation-consent/dialog-confirmation-consent.component';
import { ToastComponent } from './components/toast/toast.component';
import { LoadingComponent } from './components/loading/loading.component';
import { PrivacyPolicyComponent } from './components/privacyPolicy/privacyPolicy.component';
import { PrivacyPolicyWithoutRadioComponent } from './components/privacyPolicy-withoutradio/privacyPolicy-withoutradio.component';
import { PrivacyPolicyPersonalizedComponent } from './components/privacyPolicyPersonalized/privacyPolicyPersonalized.component';
import { PrivacyPolicyPersonalizedWithoutRadioComponent } from './components/privacyPolicyPersonalized-withoutradio/privacyPolicyPersonalized-withoutradio.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { OnlynumberDirective } from './directives/onlynumber.directive';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { GoogleAnalyticsEventsService } from './services/google-analytics.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    OtpComponent,
    ConsentComponent,
    ConsentWithoutRadioComponent,
    DialogModalComponent,
    DialogConsentComponent,
    DialogTncComponent,
    DialogComponent,
    DialogConfirmationComponent,
    DialogConfirmationConsentComponent,
    ToastComponent,
    LoadingComponent,
    PrivacyPolicyComponent,
    PrivacyPolicyWithoutRadioComponent,
    PrivacyPolicyPersonalizedComponent,
    PrivacyPolicyPersonalizedWithoutRadioComponent,
    OnlynumberDirective,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    FormsModule,
    MatCardModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatRadioModule,
    MatGridListModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    NgbModule,
    HttpClientModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [GoogleAnalyticsEventsService],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

